var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAdmin && _vm.codeObj.code)?_c('v-btn',{attrs:{"small":"","color":"orange","icon":"","loading":_vm.loading},on:{"click":function($event){return _vm.toggleFavorite()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.isFavorite ? "mdi-star" : "mdi-star-outline"))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }